"use client";

import { getInnerQueryData } from "@nimble/react-requests/data/response-utils";
import { UseFormReturn, useWatch } from "react-hook-form";

import { FilterValues } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/filter-schema";
import { ActiveSelection } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/saved-search-and-preferences/active-selection";
import { usePreferenceFilters } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/saved-search-and-preferences/use-preference-filters";
import {
  filtersMatch,
  resolveSearchAddress,
  toFilterValues,
} from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/saved-search-and-preferences/utils";
import {
  toSavedSearchesParams,
  useUserSavedSearches,
} from "@/hooks/data/use-user-saved-searches";
import useStateConfig from "@/hooks/use-state-config";
import { useAuth } from "@/stores/use-auth";

export function useActiveSelectionValue(
  form: UseFormReturn<FilterValues>,
): ActiveSelection {
  const { user } = useAuth();
  const { preferenceFilters, hasSupportedLocationPreference } =
    usePreferenceFilters();
  const { abbreviation, defaultSearchAddress } = useStateConfig();
  const params = toSavedSearchesParams(abbreviation);
  const query = useUserSavedSearches(user?.id, params, {
    enabled: !!user?.id,
  });
  const savedSearches = getInnerQueryData(query)?.searches;

  const values = useWatch({ control: form.control });

  if (
    hasSupportedLocationPreference &&
    preferenceFilters &&
    filtersMatch(values, preferenceFilters)
  ) {
    return { kind: "preferences" };
  }
  const comparableValues: FilterValues = {
    ...values,
    address: resolveSearchAddress(values.address, defaultSearchAddress),
  };
  const hit = savedSearches?.find((search) =>
    filtersMatch(comparableValues, toFilterValues(search.filters)),
  );
  if (hit) return { kind: "savedSearch", uuid: hit.uuid };
  return { kind: "none" };
}
